"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REGISTER = exports.REGISTER = "register";
var LOGIN = exports.LOGIN = "login";
var PASSWORD_RESET = exports.PASSWORD_RESET = "password_reset";
var PASSWORD_RESET_ENTRY = exports.PASSWORD_RESET_ENTRY = "password_reset_entry";